var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { useToggle } from "../../hooks";
import { Dropdown } from './';
var buttonBuildLss = function (activateBackground) { return ({
    position: 'relative',
    px: 'sm',
    width: '40px',
    height: '40px',
    color: 'white',
    borderRadius: 'rounded',
    ':not([disabled]):hover': activateBackground
        ? {
            color: 'white',
            textDecoration: 'none',
            bg: 'opacityLight'
        }
        : { background: 'none', opacity: 0.3, textDecoration: 'none' },
    ':focus': activateBackground
        ? {
            outline: 'none',
            bg: 'opacityLight',
            boxShadow: '0px 0px 5px #1166DD'
        }
        : { bg: 'inherit' },
    ':active': activateBackground
        ? {
            bg: 'opacityLight'
        }
        : { bg: 'inherit' }
}); };
export var contentBuildLss = function (showArrow, arrowColor, position) {
    return {
        top: 55,
        minWidth: 200,
        px: 0,
        pt: 0,
        pb: 'xs',
        overflowY: 'visible',
        overflowX: 'visible',
        '::before': showArrow
            ? {
                content: ' ',
                position: 'absolute',
                border: '8px solid transparent' /* arrow size */,
                borderBottomColor: arrowColor /* arrow color */,
                top: -16,
                right: position === 'left' ? 12 : 'auto',
                left: position === 'right' ? 12 : 'auto'
            }
            : {}
    };
};
export var ControlledIconDropdown = function (_a) {
    var props = __rest(_a, []);
    var _b = __read(useToggle(false), 2), isOpen = _b[0], onToggle = _b[1];
    return (React.createElement(UncontrolledIconDropdown, __assign({ isOpen: isOpen, onToggle: onToggle }, props)));
};
export var UncontrolledIconDropdown = function (_a) {
    var id = _a.id, icon = _a.icon, render = _a.render, children = _a.children, lss = _a.lss, _b = _a.disableBackdrop, disableBackdrop = _b === void 0 ? true : _b, _c = _a.isResponsive, isResponsive = _c === void 0 ? false : _c, _d = _a.buttonProps, buttonProps = _d === void 0 ? {} : _d, _e = _a.contentProps, contentProps = _e === void 0 ? { position: 'left' } : _e, isOpen = _a.isOpen, onToggle = _a.onToggle, ariaLabel = _a.ariaLabel, _f = _a.showArrow, showArrow = _f === void 0 ? false : _f, _g = _a.arrowColor, arrowColor = _g === void 0 ? 'white' : _g, _h = _a.activateBackground, activateBackground = _h === void 0 ? true : _h;
    return (React.createElement(Dropdown, { id: id, render: render, ariaLabel: ariaLabel, label: icon, disableBackdrop: disableBackdrop, isResponsive: isResponsive, lss: __assign({ mx: 'xxs', tablet: { mx: 'sm' } }, lss), buttonProps: __assign(__assign({ palette: 'primary', emphasis: 'low', scale: 'sm' }, buttonProps), { lss: __assign(__assign({}, buttonBuildLss(activateBackground)), buttonProps.lss) }), contentProps: __assign(__assign({ position: contentProps.position }, contentProps), { lss: __assign(__assign({}, contentBuildLss(showArrow, arrowColor, contentProps.position)), contentProps.lss) }), onToggle: onToggle, isOpen: isOpen }, children));
};
/**
 * This component can work both in an uncontrolled fashion by passing a boolean value to the isOpen prop
 * or it can be controlled when not passing an isOpen prop
 */
export var IconDropdown = function (_a) {
    var props = __rest(_a, []);
    return typeof props.isOpen === 'boolean' ? (React.createElement(UncontrolledIconDropdown, __assign({}, props))) : (React.createElement(ControlledIconDropdown, __assign({}, props)));
};
//# sourceMappingURL=IconDropdown.js.map